<template>
  <section class="HomePlans">
    <div class="HomePlans__inner max-w-page">
      <div class="HomePlans__copy">
        <p class="HomePlans__kicker">
          Adaptive training plans
          <span class="HomePlans__beta">Beta</span>
        </p>
        <h2 class="HomePlans__title">{{ title }}</h2>
        <p class="HomePlans__lead">{{ lead }}</p>
        <div class="HomePlans__actions">
          <router-link :to="{ name: 'cyclingTrainingPlans' }" title="Adaptive cycling training plans">
            <AppButton primary>{{ buttonText }}</AppButton>
          </router-link>
        </div>
      </div>
      <PlanShowcase :ftp="!ask" :ask="ask" :note="note" :note-label="noteLabel" />
    </div>
  </section>
</template>

<script>
import PlanShowcase from 'components/PlanShowcase'

// The training plan pitch for pages that link to the plans landing page
// (homepage, AI coach page): one catchy line, the everyday disruptions as
// questions, one promise. Copy and the floating cards are per page.
export default {
  name: 'TrainingPlansPromo',
  components: { PlanShowcase },
  props: {
    title: { type: String, default: 'Miss a ride without missing a beat' },
    lead: {
      type: String,
      default: 'Work trip? Head cold? Bad night’s sleep? Your training plan rebuilds itself after every ride, so nothing piles up and you keep getting faster.'
    },
    buttonText: { type: String, default: 'See how it adapts' },
    ask: { type: String, default: null },
    note: { type: String, default: 'Plan rebuilt. Tuesday’s missed ride is let go, and nothing is piled onto Saturday.' },
    noteLabel: { type: String, default: null }
  }
}
</script>

<style lang="postcss" scoped>
.HomePlans {
  @apply px-6 py-20 text-white;
  background: radial-gradient(ellipse 45% 55% at 90% 30%, rgba(255, 89, 51, 0.14), transparent 70%), #001116;
}
@media (min-width: 768px) {
  .HomePlans {
    @apply px-8 py-32;
  }
}
.HomePlans__inner {
  @apply grid items-center gap-16 mx-auto;
  grid-template-columns: minmax(0, 1fr);
}
@media (min-width: 1024px) {
  .HomePlans__inner {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    column-gap: 5rem;
  }
}
.HomePlans__kicker {
  @apply flex items-center gap-3 text-base font-semibold;
  color: #b6ffc9;
}
.HomePlans__beta {
  @apply px-2 py-px text-xs font-semibold rounded;
  color: #001116;
  background: #b6ffc9;
}
.HomePlans__title {
  @apply mt-5 font-bold;
  font-size: clamp(2.5rem, 4.8vw, 4rem);
  line-height: 1.02;
  letter-spacing: -0.035em;
  max-width: 13ch;
}
.HomePlans__lead {
  @apply mt-6 text-lg leading-relaxed;
  max-width: 32rem;
  color: rgba(232, 238, 242, 0.85);
}
.HomePlans__actions {
  @apply mt-9;
}
</style>
